module.exports = __webpack_public_path__ + "static/page-9-c7f7de9c79a7054e449c431bf0dbba8e.jpg";